import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Nav,
	Label
} from 'reactstrap';
import PropTypes from 'prop-types';
import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import { Link } from 'react-router-dom';
import { logout , toggleOnlineStatusApiCall } from '../../store/actions/userActions';
import { toggleData, updateBranchInServiceStatus, fetchCompanyBranches, updateSelectedBranch } from '../../store/actions/branches/branchActions';
import { getCountries } from '../../store/actions/initialState';
import { connect } from 'react-redux';
import { zerofilled } from '../../store/actions/UtilsOperation';
import { onResize } from '../../store/actions/initialState';
import { fillDashboardStatistics } from '../../store/actions/orderActions';
import {
	BRANCH_ACCESS,
	COMPANY_ACCESS
} from '../../constants/general';
import { SearchBranchSelect }  from '../../views/Plugins/SpecialForm';
const propTypes = {
  children: PropTypes.node,
};


const defaultProps = {};
class DefaultHeader extends Component {
	constructor(props) {
		super(props);
		let enableNotification = JSON.parse(localStorage.getItem("enableNotification"))
		if (enableNotification === null || enableNotification === undefined){
			enableNotification = true
		}
		let hasUnreadMessages = JSON.parse(localStorage.getItem("hasUnreadMessages"))
		if (hasUnreadMessages === null || hasUnreadMessages === undefined){
			hasUnreadMessages = false
		}
		this.state = {
			enableNotification: enableNotification,
			hasUnreadMessages: hasUnreadMessages,
			changingStatus: false
		}
		let { admin_type_id, userHigherAccess } = this.props;
		if(admin_type_id === 2 || userHigherAccess === COMPANY_ACCESS){
			this.props.fillDashboardStatistics();
		}

		this.asideTogglerRef = React.createRef();
		this.sidebarTogglerRef = React.createRef();
		this.sidebarMobileTogglerRef = React.createRef();
		this.sidebarMinimizer = React.createRef();
		this.props.getCountries()
		/*if(userHigherAccess > BRANCH_ACCESS){
			this.props.fetchCompanyBranches();
		}*/
  	}

	// addEventListener
	componentDidMount() {
		ReactDOM.findDOMNode(this.asideTogglerRef.current).addEventListener('click', this.handleContainerResize.bind(this));
		ReactDOM.findDOMNode(this.sidebarMobileTogglerRef.current).addEventListener('click', this.handleContainerResize.bind(this));
		ReactDOM.findDOMNode(this.sidebarTogglerRef.current).addEventListener('click', this.handleContainerResize.bind(this));
		window.addEventListener('hasUnreadMessages', this.handleHasUnreadMessages);

	}

	componentDidUpdate(prevProps){
		if((prevProps && prevProps.branch && prevProps.branch.id) !== (this.props.branch && this.props.branch.id)){
			this.props.fillDashboardStatistics();
		}
	}

	// removeEventListener
	componentWillUnmount() {
		if (ReactDOM.findDOMNode(this.sidebarMinimizer.current)){
			ReactDOM.findDOMNode(this.asideTogglerRef.current).removeEventListener('click', this.handleContainerResize.bind(this));
			ReactDOM.findDOMNode(this.sidebarMobileTogglerRef.current).removeEventListener('click', this.handleContainerResize.bind(this));
			ReactDOM.findDOMNode(this.sidebarTogglerRef.current).removeEventListener('click', this.handleContainerResize.bind(this));
			ReactDOM.findDOMNode(this.sidebarMinimizer.current).removeEventListener('click', this.handleContainerResize.bind(this));
		}
		window.removeEventListener('hasUnreadMessages', this.handleHasUnreadMessages);
	}

	handleHasUnreadMessages = (event) => {
		this.setState({ hasUnreadMessages: event.detail.value });
	};

	handleContainerResize(target){
		// when its clicked it still needs time to end rendering the component with the class to find, thats why I use false if its found
		if(target.currentTarget.id === "mobile-sidebar"){
			this.handleCloseNotificationsBar();
			this.props.onResize(
				document.body.classList.contains('sidebar-show'), // isSidebarActive
				undefined
			)
		}
		else if(target.currentTarget.id === "sidebar"){
			this.props.onResize(
				document.body.classList.contains('sidebar-show'), // isSidebarActive
				undefined
			)
		}
		else if (target.currentTarget.id === "aside") {
			this.props.onResize(
				undefined,
				document.body.classList.contains('aside-menu-lg-show') // isAsidemenuActive
			)
		}
	}

	activateBranch =({ checked })=>{
		this.setState({
			changingStatus: true
		}, () => {
			this.props.updateBranchInServiceStatus(checked)
			.then(() => {
				this.setState({
					changingStatus: false
				})
			});
		})
	}

	setBranch = (branch) => {
		this.props.updateSelectedBranch(branch ? branch : {});
	}

	toggleNotification = ({ checked }) => {
		localStorage.setItem(
			"enableNotification",
			JSON.stringify(checked)
		);
		this.setState({
			enableNotification: checked
		});
	}

	handleCloseNotificationsBar = () => {
		if(document.body.classList.contains('aside-menu-lg-show')){
			document.body.classList.remove('aside-menu-lg-show');
		}
	}

  	render() {
		let {
			json_lang,
			userHigherAccess,
			branch,
			statsCurrent,
			unconfirmedOrders,
			admin_type_id,
			admin_account_type,
			company,
			company_logo,
			logoLink,
			admin_type,
			session
		} = this.props;

		const { enableNotification, hasUnreadMessages } = this.state;

		var totalOngoing = statsCurrent ? statsCurrent : 0;

    	//var totalOngoing = this.props.statsCurrent && this.props.statsCurrent.unattended ? parseInt(this.props.statsCurrent.unattended,10):0;
    	var totalunconfirmed = unconfirmedOrders ? parseInt(unconfirmedOrders,10) : 0;

		return<Fragment>
				{ company && !company.enabled ? this.props.logout() : null}
				<div className="d-flex align-items-center">
					<AppSidebarToggler id="mobile-sidebar" ref={this.sidebarMobileTogglerRef} className="d-lg-none" display="md" mobile />
					<Link onClick={() => this.props.handleCloseCustomSidebar()} to={logoLink} id="company-logo-admin">
						<AppNavbarBrand tag='span'
							full={{ src: company_logo ? company_logo:
								'/assets/img/logo-default-180x64.svg',
								width:'auto', height: 42, alt: 'logo-default' }}
							minimized={{ src: '', width:0, height: 62 }}
							onError={ img => img.target.src="/assets/img/logo-default-180x64.svg"  }
					/>
					</Link>
					{
						userHigherAccess !== BRANCH_ACCESS &&
							<span onClick={() => this.props.handleCloseCustomSidebar()} className={ 'responsive_heaer show-item ml-2' }>
								<div className="d-flex flex-column align-items-center">
									<h4 className="text-primary mb-0 line_table ">{zerofilled(totalOngoing,2)}</h4>
									<span className="line_table pl-1">{json_lang.common.today_uncompleted_orders}</span>
								</div>
							</span>
					}

					{
						totalunconfirmed >0 &&
							<span onClick={() => this.props.handleCloseCustomSidebar()} className={ 'header_unconfirmed hiden-on-600 show-item ml-2' } style={{display: 'inline-table'}}>
								<div className="d-flex flex-column align-items-center">
									<h4 className="text-danger mb-0 line_table">{zerofilled(totalunconfirmed,2)}</h4>
									<span className="line_table pl-1">{json_lang.common.today_unconfirmed_orders}</span>
								</div>
							</span>
					}
				</div>
				<AppSidebarToggler id="sidebar" ref={this.sidebarTogglerRef} className="d-md-down-none" display="lg" />
				
				{
					userHigherAccess !== BRANCH_ACCESS &&
					<span onClick={() => this.props.handleCloseCustomSidebar()} className={ 'responsive_heaer hide-item' }>
						<h4 className="text-primary mb-0 line_table ">{zerofilled(totalOngoing,2)}</h4>
						<span className="line_table pl-1">{json_lang.common.today_uncompleted_orders}</span>
					</span>
				}

				{
					totalunconfirmed >0 &&
					<span onClick={() => this.props.handleCloseCustomSidebar()} className={ 'header_unconfirmed hiden-on-600 hide-item' } style={{display: 'inline-table'}}>
						<h4 className="text-danger mb-0 line_table">{zerofilled(totalunconfirmed,2)}</h4>
						<span className="line_table pl-1">{json_lang.common.today_unconfirmed_orders}</span>
					</span>
				}

				{/*<span className={ 'header_unconfirmed hiden-on-600 text-muted' }>
					<span className="line_table">{this.props.json_lang.settings.company_in_service}</span>
					<Label className={'line_table pl-1 switch switch-3d switch-info form-check-label'}>
						<input type="checkbox"
							className={ 'switch-input form-check-input hidden' }
							name={'in_service2'}
							checked={ (this.props.company && this.props.company.in_service) || false }
							onChange = { (e) => this.activateBranch(e.target) } />
						<span className="switch-slider" data-checked="On" data-unchecked="Off"></span>
					</Label>
				</span>*/}

				{
					(admin_type !== 'Shopper') &&  (admin_type !== 'Gerente de administración') && (admin_type !== 'cocinero') && (admin_type !== 'Despachador') && userHigherAccess < COMPANY_ACCESS ?
						session && session.account && session.account.type >= 119?
							<span className={ 'header_unconfirmed text-muted' }>
								<span className="line_table">{json_lang.settings.branch_in_service}</span>
								<Label className={'line_table pl-1 switch switch-3d switch-info form-check-label'}>
									<input type="checkbox"
										className={ 'switch-input form-check-input hidden' }
										name={'in_service'}
										checked = { branch && branch.in_service }
										disabled={!(branch && branch.enabled) || this.state.changingStatus}
										onChange = { (e) => this.activateBranch(e.target) } />
									<span className="switch-slider" data-checked="On" data-unchecked="Off"></span>
								</Label>
							</span>
						: null
					: null
				}
				<Nav onClick={() => this.props.handleCloseCustomSidebar()} className="ml-auto" navbar>
					{/*
						(this.props.admin_type !== 'Gerente de administración')
						&& this.state.userBranches.length > 1?//&&   this.props.userHigherAccess > BRANCH_ACCESS * /



						//: null
					*/ }

					{
						/*(admin_type !== 'Gerente de administración')
						&& this.state.userBranches.length > 1
						//&&   this.props.userHigherAccess > BRANCH_ACCESS
						&&
						if(userHigherAccess > BRANCH_ACCESS){
										this.props.fetchCompanyBranches(query)
									}
						*/
						/*(this.props.admin_type !== 'Gerente de administración') && (userHigherAccess > BRANCH_ACCESS) ?
							<Input ref={`select_input`}
								style={{width: "fit-content"}}
								className="mr-1"
								type="select"
								value={this.props.branch && this.props.branch.id}
								onChange={(e) => this.setBranch(e.target)}
								name="branch-name" >
								{this.props.userHigherAccess === COMPANY_ACCESS ? <option value="">Todos los comercios</option> : null}

								{/*
									this.state.userBranches.map( b => <option key={b.access_id} value={b.access_id}>
										{b.related_access && b.related_access.name}
									</option>)
									*
							</Input>
						:*/
						<div className="custom-default-header">
							<SearchBranchSelect
								placeholder={this.props.branch && this.props.branch.name}
								clear={()=>this.setBranch()}
								largerInput={true}>
							</SearchBranchSelect>
							<div className="d-flex flex-row align-items-center">
								{
									process.env.REACT_APP_ENV.toUpperCase() === "DEV" ||
									process.env.REACT_APP_ENV.toUpperCase() === "DEVELOP" || 
									process.env.REACT_APP_ENV.toUpperCase() === "LOCAL" ? 
									<Link
										style={{ textDecoration: 'unset' }}
										className="text-muted ml-3 mr-2 position-relative pointer"
										to={'/inbox'}
									>

										<i className="icon-envelope font-xl"/>
										{
											hasUnreadMessages && (
												<i
													className="fa fa-circle text-warning position-absolute font-xs"
													style={{ marginLeft: "-5px" }}
												/>
											)
										}
									</Link>
									:null
								}
								<AppAsideToggler id="aside" ref={this.asideTogglerRef} className="text-muted" style={ (this.props.admin_type === 'Gerente Comercial' || this.props.admin_type === 'Reportes')?{display:`none`} :{position:'relative'}}>
									<i className="icon-bell"></i>
									{ this.props.unseenNotifications &&<i className="fa fa-circle text-warning"></i> }
								</AppAsideToggler>

								<AppHeaderDropdown direction="down" className={ 'pr-4' }>
									<DropdownToggle nav>
									{/*
										this.props.online === true ?
										<i className={"mr-2 fa fa-circle text-success"} title={this.props.json_lang.table_admins.online}/>
										:
										<i className={"mr-2 fa fa-circle force-offline"} title={this.props.json_lang.table_admins.off_line}/>
									*/}

									{this.props.session.name}
									</DropdownToggle>
									<DropdownMenu  right>
										<h6 className="dropdown-header">
											{this.props.json_lang.common.display_name}
										</h6>

										{/*
											this.props.online === true ?
											<DropdownItem onClick={ ()=>toggleOnlineStatusApiCall(false) }>
												<i className={"mr-2 nav-icon fa fa-circle text-secundary"} />
												{this.props.json_lang.table_admins.off_line }
											</DropdownItem>
											:
											<DropdownItem onClick={ ()=>toggleOnlineStatusApiCall(true) }>
												<i className={"mr-2 nav-icon fa fa-circle text-success"}/>
												{this.props.json_lang.table_admins.online}
											</DropdownItem>
										*/}

										{
											this.props.session?
												<Link tag="Button" to={`/profile/${this.props.session.id}`} className="dropdown-item">
														<i className="fa fa-user"></i>
														{this.props.json_lang.common.my_account}
												</Link>
											:null
										}
										<DropdownItem onClick={ () => this.props.logout() }>
											<i className="fa fa-lock"></i>
											{this.props.json_lang.default_header.logout_button}
										</DropdownItem>
										<h6 className=" dropdown-header">
											<div className="d-flex flex-row align-items-center justify-content-between">
												{`Notificaciones`}
												<Label className={'switch switch-3d switch-info form-check-label'}>
													<input type="checkbox"
														className={'switch-input form-check-input hidden'}
														name={'enableNotification'}
													onChange={(e) => this.toggleNotification(e.target)}
													value={enableNotification}
													checked={enableNotification}/>
												<span className="switch-slider" data-checked="On" data-unchecked="Off"></span>
											</Label>
										</div>
									</h6>
									</DropdownMenu>
								</AppHeaderDropdown>
							</div>
						</div>

					}

				</Nav>

		</Fragment>
  	}
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => {
	//console.log("dashboard",state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing && state.dashboardStatistics.orders.ongoing.hanging)
	return {
		admin_type:state.session && state.session.admin_type && state.session.admin_type.name,
		admin_account_type:state.session && state.session.account && state.session.account.type,
		admin_type_id:state.session && state.session.admin_type && state.session.admin_type.id ? state.session.admin_type.id : "",
		company:state.company,
		userHigherAccess: state.userHigherAccess,
		branch:state.branch,
		branches: state.branches,
		session: state.session,
		unseenNotifications: state.unseenNotifications,
		errors: state.errors,
		online: state.userIsOnline,
		json_lang: state.json_lang,
		defaultDashboard:state.company.options,
		company_logo:state.company && state.company.styles_json && state.company.styles_json.styles && state.company.styles_json.styles.company_logo,
		company_logo_small:state.branches.logo_url,
		//statsCurrent: state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing,
		statsCurrent: state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing && state.dashboardStatistics.orders.ongoing.unattended,
		unconfirmedOrders: state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.unattended && state.dashboardStatistics.orders.unattended.unconfirmed,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logout: () => dispatch(logout()),
		onResize: (isSidebarActive, isAsidemenuActive) => dispatch(onResize(isSidebarActive, isAsidemenuActive)),
		toggleOnlineStatusApiCall: (status) => dispatch(toggleOnlineStatusApiCall(status)),
		fillDashboardStatistics: () => dispatch(fillDashboardStatistics()),
		updateSelectedBranch: (userBranch) => dispatch(updateSelectedBranch(userBranch)),
		updateBranchInServiceStatus: (enabled) => dispatch(updateBranchInServiceStatus(enabled)),
		fetchCompanyBranches: (limit,query) => dispatch(fetchCompanyBranches(limit,query)),
		toggleData: (input) => dispatch(toggleData(input)),
		getCountries: () => dispatch(getCountries()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeader);



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js